import { render } from "./AccountBalance.vue?vue&type=template&id=e63d3678&scoped=true"
import script from "./AccountBalance.vue?vue&type=script&lang=js"
export * from "./AccountBalance.vue?vue&type=script&lang=js"

import "./AccountBalance.vue?vue&type=style&index=0&id=e63d3678&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e63d3678"]])

export default __exports__